import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/kalender',
    name: 'kalender',
    component: () => lazyLoadView(import('@views/admin/kalender/List.vue')),
    meta: {
      title: 'Kelola Operasional',
    },
  },
];
